// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BookFormModal Styles */

.book-form-modal {
  max-width: 1300px;
  width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.book-form-modal .modal-header {
  padding: 1.5rem 2rem;
  flex-shrink: 0;
}

.book-form-modal .modal-title {
  font-size: 1.375rem;
}

.book-form-modal .modal-body {
  padding: 1rem 1.25rem;
  overflow-y: auto;
  flex: 1 1;
}

/* Upload Method Tabs */
.upload-method-tabs {
  display: flex;
  gap: 0;
  padding: 0 2rem 1.5rem;
  border-bottom: 2px solid var(--slate-200);
}

.tab-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.875rem 1.5rem;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-sub);
  cursor: pointer;
  transition: all var(--transition-fast);
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}

.tab-btn:hover {
  color: var(--primary);
  background: rgba(99, 102, 241, 0.05);
}

.tab-btn.active {
  color: var(--primary);
  border-bottom-color: var(--primary);
  background: rgba(99, 102, 241, 0.05);
}

.tab-btn .material-symbols-outlined {
  font-size: 20px;
}

/* Add Mode Switch */
.add-mode-switch {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 0.25rem;
  background: var(--slate-100);
  border-radius: var(--radius-lg);
}

.mode-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-sub);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.mode-btn:hover {
  color: var(--text-main);
  background: var(--slate-200);
}

.mode-btn.active {
  background: var(--surface-light);
  color: var(--primary);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.mode-btn .material-symbols-outlined {
  font-size: 18px;
}

/* Content Wrapper - Cover on left, fields flowing on right */
.form-content-wrapper {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.25rem;
  align-items: flex-start;
}

.cover-image-section {
  flex-shrink: 0;
  width: 200px;
}

.form-fields-section {
  flex: 1 1;
  min-width: 0;
}

/* Compact Grid for form fields */
.form-grid-compact {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.book-form-modal .modal-actions {
  padding: 0.75rem 1.25rem;
  gap: 0.75rem;
}

/* ISBN Lookup Group */
.isbn-lookup-group {
  margin-bottom: 0.3rem;
}

.isbn-lookup-group .form-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.isbn-lookup-group .hint {
  font-size: 0.75rem;
  font-weight: 400;
  color: var(--text-sub);
}

.isbn-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.isbn-input-wrapper .form-input {
  flex: 1 1;
  padding-right: 2.5rem;
}

.isbn-input-wrapper .loading-icon {
  position: absolute;
  right: 0.75rem;
  animation: spin 1s linear infinite;
}

/* Lookup Message */
.lookup-message {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.5rem 0.75rem;
  border-radius: var(--radius-md);
  font-size: 0.8125rem;
  background-color: var(--slate-100);
  color: var(--text-sub);
}

.lookup-message.success {
  background-color: #dcfce7;
  color: #166534;
}

.lookup-message .material-symbols-outlined {
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
}

.form-group .form-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
}

.form-group .form-input,
.form-group .form-textarea {
  padding: 0.25rem 0.75rem;
  font-size: 0.9375rem;
  border: 1px solid var(--slate-200);
  border-radius: var(--radius-lg);
  transition: all var(--transition-fast);
}

.form-group .form-input:focus,
.form-group .form-textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);
  outline: none;
}

.form-group .form-input::placeholder,
.form-group .form-textarea::placeholder {
  color: var(--slate-400);
}

.form-group .form-textarea {
  resize: vertical;
  min-height: 100px;
}

/* Cover Preview */
.cover-preview {
  position: relative;
  margin-top: 0.3rem;
  width: 100%;
  aspect-ratio: 2/3.2;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  background-color: var(--slate-100);
}

.cover-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cover-preview-empty {
  margin-top: 0.3rem;
  width: 100%;
  aspect-ratio: 2/3.2;
  border-radius: var(--radius-md);
  background-color: transparent;
  border: 2px dashed var(--slate-200);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  text-align: center;
}

.cover-preview-empty .material-symbols-outlined {
  font-size: 48px;
  color: var(--slate-400);
}

/* Placeholder preview content (shows title and author when no cover) */
.cover-preview-empty .placeholder-preview-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
  height: 100%;
}

.cover-preview-empty .placeholder-preview-title {
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cover-preview-empty .placeholder-preview-author {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--text-sub);
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.btn-remove-image {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: background-color 0.2s;
}

.btn-remove-image:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.btn-remove-image .material-symbols-outlined {
  font-size: 14px;
}

.image-upload-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-file-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  overflow: hidden;
}

.image-upload-wrapper .btn {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  cursor: pointer;
  padding: 0.375rem 0.625rem;
  font-size: 0.8125rem;
}

.image-upload-wrapper .btn .material-symbols-outlined {
  font-size: 16px;
}

.btn-sm {
  padding: 0.375rem 0.625rem;
  font-size: 0.8125rem;
}

.form-hint {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin-top: 0.25rem;
}

/* Uploaded Images Grid */
.uploaded-images-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  gap: 0.5rem;
  margin-top: 0.75rem;
  padding: 0.75rem;
  background: var(--slate-100);
  border-radius: var(--radius-lg);
}

.uploaded-image-item {
  position: relative;
  aspect-ratio: 2/3;
  border-radius: var(--radius-md);
  overflow: hidden;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
  background: var(--slate-200);
}

.uploaded-image-item:hover {
  border-color: var(--primary);
  transform: translateY(-2px);
}

.uploaded-image-item.selected {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--primary-light);
}

.uploaded-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.remove-uploaded-image {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 2;
}

.uploaded-image-item:hover .remove-uploaded-image {
  opacity: 1;
}

.remove-uploaded-image:hover {
  background: #dc2626;
  transform: scale(1.1);
}

.isbn-badge {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(34, 197, 94, 0.9);
  color: white;
  font-size: 0.625rem;
  padding: 0.25rem 0.375rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.isbn-badge .material-symbols-outlined {
  font-size: 12px;
  flex-shrink: 0;
}

.extract-isbn-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(79, 70, 229, 0.9);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.2s;
  z-index: 1;
}

.uploaded-image-item:hover .extract-isbn-btn {
  opacity: 1;
}

.extract-isbn-btn:hover {
  background: var(--primary);
  transform: translate(-50%, -50%) scale(1.1);
}

.extract-isbn-btn .material-symbols-outlined {
  font-size: 20px;
}

.extracting-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
}

.extracting-overlay .material-symbols-outlined {
  color: white;
  font-size: 24px;
}

.extract-error {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(239, 68, 68, 0.9);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.extract-error .material-symbols-outlined {
  font-size: 18px;
}

.required {
  color: var(--error-text);
}

/* Alert styles */
.alert {
  padding: 0.75rem 1rem;
  border-radius: var(--radius-lg);
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.alert-error {
  background-color: var(--error-bg);
  color: var(--error-text);
  border: 1px solid var(--error-border);
}

.alert-warning {
  background-color: #fef3c7;
  color: #92400e;
  border: 1px solid #fcd34d;
}

/* Bulk Upload Info */
.bulk-upload-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 2rem;
  background: rgba(99, 102, 241, 0.05);
  border-radius: var(--radius-lg);
  text-align: center;
}

.bulk-upload-info .material-symbols-outlined {
  font-size: 48px;
  color: var(--primary);
}

.bulk-upload-info p {
  font-size: 1rem;
  color: var(--text-sub);
  margin: 0;
}

/* Simplified Bulk Upload Modal */
.bulk-upload-modal-simple {
  max-width: 1000px;
  width: 95%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.bulk-upload-modal-simple .modal-body {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* Bulk Upload Area */
.bulk-upload-area {
  width: 100%;
}

.upload-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  border: 3px dashed var(--border-color);
  border-radius: var(--radius-lg);
  background: var(--slate-50);
  cursor: pointer;
  transition: all var(--transition-fast);
  text-align: center;
}

.upload-dropzone:hover {
  border-color: var(--primary);
  background: rgba(99, 102, 241, 0.05);
}

.upload-dropzone .file-input {
  display: none;
}

.upload-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--primary);
  border-radius: 50%;
  margin-bottom: 1rem;
}

.upload-icon .material-symbols-outlined {
  font-size: 40px;
  color: white;
}

.upload-dropzone h3 {
  font-size: 1.25rem;
  color: var(--text-main);
  margin: 0 0 0.5rem 0;
}

.upload-dropzone p {
  font-size: 0.875rem;
  color: var(--text-sub);
  margin: 0;
}

/* Upload Summary */
.upload-summary {
  padding: 1rem;
  background: var(--slate-50);
  border-radius: var(--radius-md);
}

.summary-stats {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.summary-stats .stat {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
}

.summary-stats .stat .material-symbols-outlined {
  font-size: 18px;
}

.summary-stats .stat.ready {
  color: #059669;
}

.summary-stats .stat.error {
  color: #dc2626;
}

.summary-stats .stat.total {
  color: var(--text-sub);
  margin-left: auto;
}

.summary-stats .stat.submitted {
  color: #2563eb;
}

.summary-stats .stat.submitting {
  color: #1e40af;
}

.summary-stats .stat.processing {
  color: #d97706;
}

.summary-stats .stat.skipped {
  color: #6b7280;
}

/* Previews Grid */
.previews-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 1rem;
  max-height: 400px;
  overflow-y: auto;
  padding: 0.5rem;
}

.preview-card {
  background: white;
  border-radius: var(--radius-md);
  border: 2px solid var(--border-color);
  overflow: hidden;
  transition: all var(--transition-fast);
}

.preview-card.status-ready {
  border-color: #10b981;
}

.preview-card.status-error {
  border-color: #ef4444;
}

.preview-card.status-processing {
  border-color: #f59e0b;
}

.preview-card.status-submitting {
  border-color: #3b82f6;
}

.preview-card.status-submitted {
  border-color: #10b981;
}

.preview-card.status-skipped {
  border-color: #9ca3af;
}

.preview-card.status-completed {
  border-color: #10b981;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: var(--slate-100);
}

.preview-number {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--text-sub);
}

.remove-btn {
  background: transparent;
  border: none;
  color: var(--text-sub);
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: all var(--transition-fast);
}

.remove-btn:hover {
  background: var(--slate-200);
  color: var(--error);
}

.remove-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.preview-image {
  position: relative;
  width: 100%;
  height: 150px;
  background: var(--slate-50);
}

.preview-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.processing-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.75rem;
}

.processing-overlay .spinning {
  animation: spin 1s linear infinite;
  font-size: 24px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.preview-info {
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-height: 140px;
}

.book-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-main);
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.book-author {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin: 0;
}

.book-publisher,
.book-category,
.book-year {
  font-size: 0.6875rem;
  color: var(--text-sub);
  margin: 0;
}

.book-isbn {
  font-size: 0.6875rem;
  color: var(--text-sub);
  font-family: monospace;
  margin: 0;
}

.error-message {
  font-size: 0.75rem;
  color: #dc2626;
  margin: 0;
}

.processing-text,
.pending-text {
  font-size: 0.75rem;
  color: var(--text-sub);
  margin: 0;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  align-self: flex-start;
}

.status-badge.ready {
  background: #d1fae5;
  color: #065f46;
}

.status-badge.error {
  background: #fee2e2;
  color: #991b1b;
}

.status-badge.processing {
  background: #fef3c7;
  color: #92400e;
}

.status-badge.pending {
  background: var(--slate-200);
  color: var(--text-sub);
}

.status-badge.submitted {
  background: #dbeafe;
  color: #1e40af;
}

.status-badge.submitting {
  background: #bfdbfe;
  color: #1e3a8a;
}

/* Minimized Modal State */
.bulk-upload-modal-simple.minimized {
  max-width: 400px;
}

.bulk-upload-modal-simple.minimized .modal-body {
  display: none;
}

.bulk-upload-modal-simple.minimized .modal-header {
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.bulk-upload-modal-simple.minimized .modal-title {
  color: white;
  font-size: 0.875rem;
}

.bulk-upload-modal-simple.minimized .modal-close {
  color: white;
}

/* Success Overlay */
.success-overlay {
  position: absolute;
  inset: 0;
  background: rgba(16, 185, 129, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.75rem;
}

.success-overlay .material-symbols-outlined {
  font-size: 24px;
}

/* Skipped Overlay */
.skipped-overlay {
  position: absolute;
  inset: 0;
  background: rgba(107, 114, 128, 0.9);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: white;
  font-size: 0.75rem;
}

.skipped-overlay .material-symbols-outlined {
  font-size: 24px;
}

/* Skipped Text */
.skipped-text {
  color: #6b7280;
  font-size: 0.875rem;
  text-align: center;
  margin-bottom: 0.5rem;
}

/* Status Badge Skipped */
.status-badge.skipped {
  background: #e5e7eb;
  color: #6b7280;
  padding: 0.25rem 0.75rem;
  border-radius: var(--radius-full);
  font-size: 0.75rem;
  font-weight: 600;
  display: inline-block;
}

/* Preview Card Skipped */
.preview-card.status-skipped {
  border: 2px solid #e5e7eb;
}

@media (max-width: 768px) {
  .form-content-wrapper {
    flex-direction: column;
    align-items: center;
    gap: 0.4rem;
  }

  .cover-image-section {
    width: 100%;
    max-width: 200px;
  }

  .form-grid-compact {
    width: 100%;
  }

  .cover-preview {
    max-width: 200px;
    margin: 0.3rem auto 0;
  }

  .cover-preview-empty {
    max-width: 200px;
    margin: 0.3rem auto 0;
  }

  .book-form-modal .modal-header {
    padding: 0.75rem 1rem;
  }

  .book-form-modal .modal-body {
    padding: 0.75rem 1rem;
  }

  .book-form-modal .modal-actions {
    padding: 0.75rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/admin/BookFormModal.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,SAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,MAAM;EACN,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,kCAAkC;EAClC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,4BAA4B;EAC5B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,wCAAwC;EACxC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA,uEAAuE;AACvE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kCAAkC;EAClC,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,SAAS;AACX;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;;;EAGE,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":["/* BookFormModal Styles */\n\n.book-form-modal {\n  max-width: 1300px;\n  width: 95%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.book-form-modal .modal-header {\n  padding: 1.5rem 2rem;\n  flex-shrink: 0;\n}\n\n.book-form-modal .modal-title {\n  font-size: 1.375rem;\n}\n\n.book-form-modal .modal-body {\n  padding: 1rem 1.25rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n/* Upload Method Tabs */\n.upload-method-tabs {\n  display: flex;\n  gap: 0;\n  padding: 0 2rem 1.5rem;\n  border-bottom: 2px solid var(--slate-200);\n}\n\n.tab-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.875rem 1.5rem;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -2px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n\n.tab-btn:hover {\n  color: var(--primary);\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.tab-btn.active {\n  color: var(--primary);\n  border-bottom-color: var(--primary);\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.tab-btn .material-symbols-outlined {\n  font-size: 20px;\n}\n\n/* Add Mode Switch */\n.add-mode-switch {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  padding: 0.25rem;\n  background: var(--slate-100);\n  border-radius: var(--radius-lg);\n}\n\n.mode-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-md);\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-sub);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n}\n\n.mode-btn:hover {\n  color: var(--text-main);\n  background: var(--slate-200);\n}\n\n.mode-btn.active {\n  background: var(--surface-light);\n  color: var(--primary);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.mode-btn .material-symbols-outlined {\n  font-size: 18px;\n}\n\n/* Content Wrapper - Cover on left, fields flowing on right */\n.form-content-wrapper {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 0.25rem;\n  align-items: flex-start;\n}\n\n.cover-image-section {\n  flex-shrink: 0;\n  width: 200px;\n}\n\n.form-fields-section {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Compact Grid for form fields */\n.form-grid-compact {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.book-form-modal .modal-actions {\n  padding: 0.75rem 1.25rem;\n  gap: 0.75rem;\n}\n\n/* ISBN Lookup Group */\n.isbn-lookup-group {\n  margin-bottom: 0.3rem;\n}\n\n.isbn-lookup-group .form-label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.isbn-lookup-group .hint {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: var(--text-sub);\n}\n\n.isbn-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.isbn-input-wrapper .form-input {\n  flex: 1;\n  padding-right: 2.5rem;\n}\n\n.isbn-input-wrapper .loading-icon {\n  position: absolute;\n  right: 0.75rem;\n  animation: spin 1s linear infinite;\n}\n\n/* Lookup Message */\n.lookup-message {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: var(--radius-md);\n  font-size: 0.8125rem;\n  background-color: var(--slate-100);\n  color: var(--text-sub);\n}\n\n.lookup-message.success {\n  background-color: #dcfce7;\n  color: #166534;\n}\n\n.lookup-message .material-symbols-outlined {\n  font-size: 16px;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n}\n\n.form-group .form-label {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n}\n\n.form-group .form-input,\n.form-group .form-textarea {\n  padding: 0.25rem 0.75rem;\n  font-size: 0.9375rem;\n  border: 1px solid var(--slate-200);\n  border-radius: var(--radius-lg);\n  transition: all var(--transition-fast);\n}\n\n.form-group .form-input:focus,\n.form-group .form-textarea:focus {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(99, 101, 241, 0.1);\n  outline: none;\n}\n\n.form-group .form-input::placeholder,\n.form-group .form-textarea::placeholder {\n  color: var(--slate-400);\n}\n\n.form-group .form-textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Cover Preview */\n.cover-preview {\n  position: relative;\n  margin-top: 0.3rem;\n  width: 100%;\n  aspect-ratio: 2/3.2;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n  background-color: var(--slate-100);\n}\n\n.cover-preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cover-preview-empty {\n  margin-top: 0.3rem;\n  width: 100%;\n  aspect-ratio: 2/3.2;\n  border-radius: var(--radius-md);\n  background-color: transparent;\n  border: 2px dashed var(--slate-200);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  text-align: center;\n}\n\n.cover-preview-empty .material-symbols-outlined {\n  font-size: 48px;\n  color: var(--slate-400);\n}\n\n/* Placeholder preview content (shows title and author when no cover) */\n.cover-preview-empty .placeholder-preview-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n  height: 100%;\n}\n\n.cover-preview-empty .placeholder-preview-title {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: var(--text-main);\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.cover-preview-empty .placeholder-preview-author {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--text-sub);\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.btn-remove-image {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: rgba(0, 0, 0, 0.6);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  transition: background-color 0.2s;\n}\n\n.btn-remove-image:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n\n.btn-remove-image .material-symbols-outlined {\n  font-size: 14px;\n}\n\n.image-upload-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.form-file-input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.image-upload-wrapper .btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  cursor: pointer;\n  padding: 0.375rem 0.625rem;\n  font-size: 0.8125rem;\n}\n\n.image-upload-wrapper .btn .material-symbols-outlined {\n  font-size: 16px;\n}\n\n.btn-sm {\n  padding: 0.375rem 0.625rem;\n  font-size: 0.8125rem;\n}\n\n.form-hint {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin-top: 0.25rem;\n}\n\n/* Uploaded Images Grid */\n.uploaded-images-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n  gap: 0.5rem;\n  margin-top: 0.75rem;\n  padding: 0.75rem;\n  background: var(--slate-100);\n  border-radius: var(--radius-lg);\n}\n\n.uploaded-image-item {\n  position: relative;\n  aspect-ratio: 2/3;\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: all 0.2s;\n  background: var(--slate-200);\n}\n\n.uploaded-image-item:hover {\n  border-color: var(--primary);\n  transform: translateY(-2px);\n}\n\n.uploaded-image-item.selected {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--primary-light);\n}\n\n.uploaded-image-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.remove-uploaded-image {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.2s;\n  z-index: 2;\n}\n\n.uploaded-image-item:hover .remove-uploaded-image {\n  opacity: 1;\n}\n\n.remove-uploaded-image:hover {\n  background: #dc2626;\n  transform: scale(1.1);\n}\n\n.isbn-badge {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(34, 197, 94, 0.9);\n  color: white;\n  font-size: 0.625rem;\n  padding: 0.25rem 0.375rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.isbn-badge .material-symbols-outlined {\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.extract-isbn-btn {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background: rgba(79, 70, 229, 0.9);\n  color: white;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: all 0.2s;\n  z-index: 1;\n}\n\n.uploaded-image-item:hover .extract-isbn-btn {\n  opacity: 1;\n}\n\n.extract-isbn-btn:hover {\n  background: var(--primary);\n  transform: translate(-50%, -50%) scale(1.1);\n}\n\n.extract-isbn-btn .material-symbols-outlined {\n  font-size: 20px;\n}\n\n.extracting-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 3;\n}\n\n.extracting-overlay .material-symbols-outlined {\n  color: white;\n  font-size: 24px;\n}\n\n.extract-error {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n}\n\n.extract-error .material-symbols-outlined {\n  font-size: 18px;\n}\n\n.required {\n  color: var(--error-text);\n}\n\n/* Alert styles */\n.alert {\n  padding: 0.75rem 1rem;\n  border-radius: var(--radius-lg);\n  font-size: 0.875rem;\n  margin-bottom: 1rem;\n}\n\n.alert-error {\n  background-color: var(--error-bg);\n  color: var(--error-text);\n  border: 1px solid var(--error-border);\n}\n\n.alert-warning {\n  background-color: #fef3c7;\n  color: #92400e;\n  border: 1px solid #fcd34d;\n}\n\n/* Bulk Upload Info */\n.bulk-upload-info {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 2rem;\n  background: rgba(99, 102, 241, 0.05);\n  border-radius: var(--radius-lg);\n  text-align: center;\n}\n\n.bulk-upload-info .material-symbols-outlined {\n  font-size: 48px;\n  color: var(--primary);\n}\n\n.bulk-upload-info p {\n  font-size: 1rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n/* Simplified Bulk Upload Modal */\n.bulk-upload-modal-simple {\n  max-width: 1000px;\n  width: 95%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.bulk-upload-modal-simple .modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* Bulk Upload Area */\n.bulk-upload-area {\n  width: 100%;\n}\n\n.upload-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n  border: 3px dashed var(--border-color);\n  border-radius: var(--radius-lg);\n  background: var(--slate-50);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  text-align: center;\n}\n\n.upload-dropzone:hover {\n  border-color: var(--primary);\n  background: rgba(99, 102, 241, 0.05);\n}\n\n.upload-dropzone .file-input {\n  display: none;\n}\n\n.upload-icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--primary);\n  border-radius: 50%;\n  margin-bottom: 1rem;\n}\n\n.upload-icon .material-symbols-outlined {\n  font-size: 40px;\n  color: white;\n}\n\n.upload-dropzone h3 {\n  font-size: 1.25rem;\n  color: var(--text-main);\n  margin: 0 0 0.5rem 0;\n}\n\n.upload-dropzone p {\n  font-size: 0.875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n/* Upload Summary */\n.upload-summary {\n  padding: 1rem;\n  background: var(--slate-50);\n  border-radius: var(--radius-md);\n}\n\n.summary-stats {\n  display: flex;\n  gap: 1.5rem;\n  align-items: center;\n}\n\n.summary-stats .stat {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.summary-stats .stat .material-symbols-outlined {\n  font-size: 18px;\n}\n\n.summary-stats .stat.ready {\n  color: #059669;\n}\n\n.summary-stats .stat.error {\n  color: #dc2626;\n}\n\n.summary-stats .stat.total {\n  color: var(--text-sub);\n  margin-left: auto;\n}\n\n.summary-stats .stat.submitted {\n  color: #2563eb;\n}\n\n.summary-stats .stat.submitting {\n  color: #1e40af;\n}\n\n.summary-stats .stat.processing {\n  color: #d97706;\n}\n\n.summary-stats .stat.skipped {\n  color: #6b7280;\n}\n\n/* Previews Grid */\n.previews-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 1rem;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 0.5rem;\n}\n\n.preview-card {\n  background: white;\n  border-radius: var(--radius-md);\n  border: 2px solid var(--border-color);\n  overflow: hidden;\n  transition: all var(--transition-fast);\n}\n\n.preview-card.status-ready {\n  border-color: #10b981;\n}\n\n.preview-card.status-error {\n  border-color: #ef4444;\n}\n\n.preview-card.status-processing {\n  border-color: #f59e0b;\n}\n\n.preview-card.status-submitting {\n  border-color: #3b82f6;\n}\n\n.preview-card.status-submitted {\n  border-color: #10b981;\n}\n\n.preview-card.status-skipped {\n  border-color: #9ca3af;\n}\n\n.preview-card.status-completed {\n  border-color: #10b981;\n}\n\n.preview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0.75rem;\n  background: var(--slate-100);\n}\n\n.preview-number {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--text-sub);\n}\n\n.remove-btn {\n  background: transparent;\n  border: none;\n  color: var(--text-sub);\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n  transition: all var(--transition-fast);\n}\n\n.remove-btn:hover {\n  background: var(--slate-200);\n  color: var(--error);\n}\n\n.remove-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.preview-image {\n  position: relative;\n  width: 100%;\n  height: 150px;\n  background: var(--slate-50);\n}\n\n.preview-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.processing-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.75rem;\n}\n\n.processing-overlay .spinning {\n  animation: spin 1s linear infinite;\n  font-size: 24px;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.preview-info {\n  padding: 0.75rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n  min-height: 140px;\n}\n\n.book-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-main);\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.book-author {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.book-publisher,\n.book-category,\n.book-year {\n  font-size: 0.6875rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.book-isbn {\n  font-size: 0.6875rem;\n  color: var(--text-sub);\n  font-family: monospace;\n  margin: 0;\n}\n\n.error-message {\n  font-size: 0.75rem;\n  color: #dc2626;\n  margin: 0;\n}\n\n.processing-text,\n.pending-text {\n  font-size: 0.75rem;\n  color: var(--text-sub);\n  margin: 0;\n}\n\n.status-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  align-self: flex-start;\n}\n\n.status-badge.ready {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.status-badge.error {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.status-badge.processing {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-badge.pending {\n  background: var(--slate-200);\n  color: var(--text-sub);\n}\n\n.status-badge.submitted {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.status-badge.submitting {\n  background: #bfdbfe;\n  color: #1e3a8a;\n}\n\n/* Minimized Modal State */\n.bulk-upload-modal-simple.minimized {\n  max-width: 400px;\n}\n\n.bulk-upload-modal-simple.minimized .modal-body {\n  display: none;\n}\n\n.bulk-upload-modal-simple.minimized .modal-header {\n  padding: 0.75rem 1rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.bulk-upload-modal-simple.minimized .modal-title {\n  color: white;\n  font-size: 0.875rem;\n}\n\n.bulk-upload-modal-simple.minimized .modal-close {\n  color: white;\n}\n\n/* Success Overlay */\n.success-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(16, 185, 129, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.75rem;\n}\n\n.success-overlay .material-symbols-outlined {\n  font-size: 24px;\n}\n\n/* Skipped Overlay */\n.skipped-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(107, 114, 128, 0.9);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 0.75rem;\n}\n\n.skipped-overlay .material-symbols-outlined {\n  font-size: 24px;\n}\n\n/* Skipped Text */\n.skipped-text {\n  color: #6b7280;\n  font-size: 0.875rem;\n  text-align: center;\n  margin-bottom: 0.5rem;\n}\n\n/* Status Badge Skipped */\n.status-badge.skipped {\n  background: #e5e7eb;\n  color: #6b7280;\n  padding: 0.25rem 0.75rem;\n  border-radius: var(--radius-full);\n  font-size: 0.75rem;\n  font-weight: 600;\n  display: inline-block;\n}\n\n/* Preview Card Skipped */\n.preview-card.status-skipped {\n  border: 2px solid #e5e7eb;\n}\n\n@media (max-width: 768px) {\n  .form-content-wrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.4rem;\n  }\n\n  .cover-image-section {\n    width: 100%;\n    max-width: 200px;\n  }\n\n  .form-grid-compact {\n    width: 100%;\n  }\n\n  .cover-preview {\n    max-width: 200px;\n    margin: 0.3rem auto 0;\n  }\n\n  .cover-preview-empty {\n    max-width: 200px;\n    margin: 0.3rem auto 0;\n  }\n\n  .book-form-modal .modal-header {\n    padding: 0.75rem 1rem;\n  }\n\n  .book-form-modal .modal-body {\n    padding: 0.75rem 1rem;\n  }\n\n  .book-form-modal .modal-actions {\n    padding: 0.75rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
